import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import FloatInput from "components/Input/FloatInput";
import {
  CustomSelect,
} from "components/Input/Index.js";
import uuid from "react-uuid";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import CustomSwitch from "components/Input/CustomSwitch.js";
import { putPoint } from "services/ConfigServices";
import styled from "styled-components";
import { dico } from "variables/lists/dico";
import { charttext } from "variables/chart";
import { decalageunitdata } from "variables/lists/charts";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import {
  adanceddeffromdaydata, adanceddeftodaydata, adanceddefhourdata, agregategdata,
  pointgranularitydata, pointtabgranularitydata
} from "variables/lists/charts";
import IntInput from "components/Input/IntInput";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const ChangeLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  margin: 1rem 0rem 0rem 0rem;
`;

function AdvancedDefDialogPoint(props) {
  const { closeModal, def, formulapretty, formulaprettyEdited, graphgranularity, serie, charttype } = props;

  const [granularity, setGranularity] = useState(def?.granularity || "auto");
  const [agregatg, setAgregatg] = useState(def?.agregatg || "SUM");
  const [replacebyzero, setReplacebyzero] = useState(def?.replacebyzero === 'true' || false);
  const [decalageswitch, setDecalageswitch] = useState(false);
  const [decalage, setDecalage] = useState(def?.decalage || "none");
  const [decalageunit, setDecalageunit] = useState("");
  const [decalageqty, setDecalageqty] = useState("");

  const [filter, setFilter] = useState(def?.filter || "none");

  const [filterswitch, setFilterswitch] = useState(false);
  const [fromday, setFromday] = useState("");
  const [fromhour, setFromhour] = useState("");
  const [today, setToday] = useState("");
  const [tohour, setTohour] = useState("");

  const handleGranularityChange = (event) => {
    setGranularity(event.target.value);
    if (event.target.value === 'R') {
      setAgregatg("LAST");
      setDecalage("none");
      setFilter("none");
    }
  };

  const handleAgregatgChange = (event) => {
    setAgregatg(event.target.value);
  };

  const handleReplacebyzeroChange = (event) => {
    setReplacebyzero(!replacebyzero);
  };

  const handleDecalageswitchChange = (event) => {
    if (decalageswitch)
      setDecalage("none");
    else
      setDecalage("1d");
  };
  const handleDecalageqtyChange = (event) => {
    let qty = event.target.value;
    if (decalageunit === 'h' && qty < -720)
      qty = -720;
    else if (decalageunit === 'h' && qty > 720)
      qty = 720;
    if (decalageunit === 'd' && qty < -365)
      qty = -365;
    else if (decalageunit === 'd' && qty > 365)
      qty = 365;
    if (decalageunit === 'M' && qty < -120)
      qty = -120;
    else if (decalageunit === 'M' && qty > 120)
      qty = 120;
    setDecalage(qty + decalageunit);
  };
  const handleDecalageunitChange = (event) => {
    let unit = event.target.value;
    let qty = decalageqty;
    if (unit === 'h' && decalageqty < -720)
      qty = -720;
    else if (unit === 'h' && decalageqty > 720)
      qty = 720;
    if (unit === 'd' && decalageqty < -365)
      qty = -365;
    else if (unit === 'd' && decalageqty > 365)
      qty = 365;
    if (unit === 'M' && decalageqty < -120)
      qty = -120;
    else if (unit === 'M' && decalageqty > 120)
      qty = 120;
    setDecalage(qty + unit);
  };

  const handleFilterswitchChange = (event) => {
    if (filterswitch)
      setFilter("none");
    else
      setFilter("all|0|0");
  };

  const handleFromdayChange = (event) => {
    let filtertmp = "";
    if (event.target.value === 'all' || event.target.value === 'weekdays' || event.target.value === 'weekenddays')
      filtertmp = event.target.value + "|" + fromhour + "|" + tohour;
    else
      filtertmp = event.target.value + "|" + today + "|" + fromhour + "|" + tohour;
    setFilter(filtertmp);
  };
  const handleFromhourChange = (event) => {
    let filtertmp = "";
    if (fromday === 'all' || fromday === 'weekdays' || fromday === 'weekenddays')
      filtertmp = fromday + "|" + event.target.value + "|" + tohour;
    else
      filtertmp = fromday + "|" + today + "|" + event.target.value + "|" + tohour;
    setFilter(filtertmp);
  };
  const handleTodayChange = (event) => {
    let filtertmp = "";
    if (fromday === 'all' || fromday === 'weekdays' || fromday === 'weekenddays')
      filtertmp = fromday + "|" + fromhour + "|" + tohour;
    else
      filtertmp = fromday + "|" + event.target.value + "|" + fromhour + "|" + tohour;
    setFilter(filtertmp);
  };
  const handleTohourChange = (event) => {
    let filtertmp = "";
    if (fromday === 'all' || fromday === 'weekdays' || fromday === 'weekenddays')
      filtertmp = fromday + "|" + fromhour + "|" + event.target.value;
    else
      filtertmp = fromday + "|" + today + "|" + fromhour + "|" + event.target.value;
    setFilter(filtertmp);
  };

  useEffect(() => {
    let unit = "";
    let qty = "";
    if (decalage && decalage !== "none") {
      if (decalage.includes("h")) {
        unit = 'h';
        qty = decalage.substring(0, decalage.indexOf("h"));
      }
      else if (decalage.includes("d")) {
        unit = 'd';
        qty = decalage.substring(0, decalage.indexOf("d"));
      }
      else if (decalage.includes("M")) {
        unit = 'M';
        qty = decalage.substring(0, decalage.indexOf("M"));
      }
      setDecalageswitch(true);
    }
    else
      setDecalageswitch(false);
    setDecalageunit(unit);
    setDecalageqty(qty);
  }, [decalage]);

  useEffect(() => {
    let tohourtmp = "";
    let fromhourtmp = "";
    let todaytmp = "";
    let fromdaytmp = "";
    if (filter && filter !== "none") {
      let filterdecode = filter.split("|")
      if (filterdecode.length > 0) {
        fromdaytmp = filterdecode[0];
        if (fromdaytmp === 'all' || fromdaytmp === 'weekdays' || fromdaytmp === 'weekenddays') {
          if (filterdecode.length > 1) {
            fromhourtmp = filterdecode[1];
            if (filterdecode.length > 2) {
              tohourtmp = filterdecode[2];
            }
          }
        }
        else {
          if (filterdecode.length > 1) {
            todaytmp = filterdecode[1];
            if (filterdecode.length > 2) {
              fromhourtmp = filterdecode[2];
              if (filterdecode.length > 3) {
                tohourtmp = filterdecode[3];
              }
            }
          }
        }
      }
      setFilterswitch(true);
    }
    else
      setFilterswitch(false);
    setFromday(fromdaytmp);
    setFromhour(fromhourtmp);
    setToday(todaytmp);
    setTohour(tohourtmp);
  }, [filter]);
  const classes = useStyles();


  const handleSubmit = (event) => {

    let newformulapretty = JSON.parse(JSON.stringify(formulapretty));
    let obj = newformulapretty.find((o) => o.id === def.id);
    if (obj) {
      let newobj = { ...obj };
      newobj.granularity = granularity;
      newobj.agregatg = agregatg;
      newobj.replacebyzero = replacebyzero;
      newobj.decalage = decalage;
      newobj.filter = filter;
      newformulapretty[obj.id] = newobj;
      formulaprettyEdited(newformulapretty, serie);
    }
    closeModal();
  };


  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div>
                  <CustomSelect
                    inputTitle={charttext.pointgranularity}
                    selectValue={granularity}
                    handleSelectValueChange={handleGranularityChange}
                    data={(charttype === 'tab' || charttype === 'tabequipment') ? pointtabgranularitydata : pointgranularitydata[graphgranularity]}
                  />
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div>
                  <CustomSelect
                    inputTitle={charttext.agregatg}
                    selectValue={agregatg}
                    handleSelectValueChange={handleAgregatgChange}
                    data={agregategdata}
                    disabled={granularity === 'R'}
                  />
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <ChangeLabel>{charttext.replacebyzero}</ChangeLabel>
              </GridItem>
              <GridItem xs={3} sm={3} md={3} lg={3}>
                <div>
                  <CustomSwitch
                    style={{ marginLeft: "0.5rem" }}
                    inputTitle={''}
                    checkedState={replacebyzero}
                    handleSwitchChange={handleReplacebyzeroChange}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>

          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <ChangeLabel>{charttext.decalage}</ChangeLabel>
              </GridItem>
              <GridItem xs={3} sm={3} md={3} lg={3}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={decalageswitch}
                    handleSwitchChange={handleDecalageswitchChange}
                    disabled={granularity === 'R'}
                  />
                </div>
              </GridItem>
              <GridItem xs={3} sm={3} md={3} lg={3}>
                <div>
                  <CustomSelect
                    inputTitle={charttext.decalageunit}
                    selectValue={decalageunit}
                    handleSelectValueChange={handleDecalageunitChange}
                    data={decalageunitdata[(granularity === 'H' || (granularity === 'auto' && graphgranularity === 'hour')) ? '1h' : '1d']}
                    disabled={!decalageswitch}
                  />
                </div>
              </GridItem>
              <GridItem xs={3} sm={3} md={3} lg={3}>
                <div>
                  <IntInput
                    inputTitle={charttext.decalageqty}
                    intInput={decalageqty}
                    handleIntInputChange={handleDecalageqtyChange}
                    disabled={!decalageswitch}
                    max={36}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>


          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <ChangeLabel>{charttext.changedatatimefiltering}</ChangeLabel>
              </GridItem>
              <GridItem xs={6} sm={6} md={1} lg={1}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={filterswitch}
                    handleSwitchChange={handleFilterswitchChange}
                    disabled={granularity === 'R'}
                  />
                </div>
              </GridItem>
              <GridItem xs={12} sm={12} md={11} lg={11}>
                <GridContainer>
                  <GridItem xs={6} sm={6} md={4} lg={4}>
                    <div>
                      <CustomSelect
                        inputTitle={charttext.fromday}
                        selectValue={fromday}
                        handleSelectValueChange={handleFromdayChange}
                        data={adanceddeffromdaydata}
                        disabled={!filterswitch}
                      />
                    </div>
                  </GridItem>
                  {(granularity === 'H' || (granularity === 'auto' && graphgranularity === 'hour')) ?
                    <GridItem xs={6} sm={6} md={2} lg={2}>
                      <div>
                        <CustomSelect
                          inputTitle={charttext.fromhour}
                          selectValue={fromhour}
                          handleSelectValueChange={handleFromhourChange}
                          data={adanceddefhourdata}
                          disabled={!filterswitch}
                        />
                      </div>
                    </GridItem> : <></>
                  }
                  {
                    (fromday !== 'all' && fromday !== 'weekdays' && fromday !== 'weekenddays') ?

                      <GridItem xs={6} sm={6} md={4} lg={4}>
                        <div>
                          <CustomSelect
                            inputTitle={charttext.today}
                            selectValue={today}
                            handleSelectValueChange={handleTodayChange}
                            data={adanceddeftodaydata}
                            disabled={!filterswitch}
                          />
                        </div>
                      </GridItem>
                      : <></>
                  }
                  {(granularity === 'H' || (granularity === 'auto' && graphgranularity === 'hour')) ?
                    <GridItem xs={6} sm={6} md={2} lg={2}>
                      <div>
                        <CustomSelect
                          inputTitle={charttext.tohour}
                          selectValue={tohour}
                          handleSelectValueChange={handleTohourChange}
                          data={adanceddefhourdata}
                          disabled={!filterswitch}
                        />
                      </div>
                    </GridItem> : <></>
                  }
                </GridContainer>
              </GridItem>
            </GridContainer>
          </GridItem>

        </GridContainer>
        <Button
          className={classes.submitButton}
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>

    </>
  );
}

export default AdvancedDefDialogPoint;
